import "../css/style.scss";

export default function Footer() {
  return (
    <section>
      <div id="footer" className="footer">
        <div className="bottom-line">
          <div className="copyright">© {new Date().getFullYear()} Air Guslar</div>
          <div className="privacy">
            <a onClick={() => window.open("/privacy-policy", "_blank")}> Privacy policy </a>
          </div>
        </div>
      </div>
    </section>
  );
}
